/**
 * Return an object with all null or undefined entires removed.
 */
export const filterEmptyValues = (obj: Record<any, any>): Record<any, any> =>
  Object.fromEntries(
    Object.entries(obj).filter(
      ([, _]) => _ !== null && _ !== undefined && _ !== ''
    )
  );
